// API configuration
export const API_BASE_URL = 'https://monobreak.ramon-m.workers.dev'

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/auth/login',
  REGISTER: '/api/auth/register',
  PROFILE: '/api/auth/profile',
  
  // Products
  SEARCH: '/api/products/search',
  PRODUCT: '/api/products',
  POPULAR: '/api/products/popular',
  
  // Submissions
  SUBMISSIONS: '/api/submissions',
  MY_SUBMISSIONS: '/api/submissions/my',
  SUBMISSION_STATS: '/api/submissions/stats',
  
  // Admin
  ADMIN_STATS: '/api/admin/stats',
  ADMIN_SUBMISSIONS: '/api/admin/submissions',
  ADMIN_USERS: '/api/admin/users',
  ADMIN_ROUTES: '/api/admin/alternative-routes',
}

export const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`
}
